(function () {
  'use strict';
  angular
    .module('com.module.settings')
    .config(function ($stateProvider) {
      $stateProvider
        .state('app.settings', {
          abstract: true,
          url: '/settings',
          templateUrl: 'app/modules/settings/views/main.html'
        })
        .state('app.settings.list', {
          url: '',
          templateUrl: 'app/modules/settings/views/list.html',
          controllerAs: 'ctrl',
          controller: function (settings) {
            this.settings = settings;
          },
          resolve: {
            settings: function (SettingService) {
              return SettingService.find(true);
            }
          }
        })
        .state('app.settings.add', {
          url: '/add',
          templateUrl: 'app/modules/settings/views/form.html',
          controllerAs: 'ctrl',
          controller:'SettingSingleController',
          resolve: {
            setting: function () {
              return {};
            }
          }
        })
        .state('app.settings.edit', {
          url: '/:id/edit',
          templateUrl: 'app/modules/settings/views/form.html',
          controllerAs: 'ctrl',
          controller:'SettingSingleController',
          resolve: {
            setting: function ($stateParams, SettingService) {
              return SettingService.findById($stateParams.id);
            }
          }
        })
        .state('app.settings.view', {
          url: '/:id',
          templateUrl: 'app/modules/settings/views/view.html',
          controllerAs: 'ctrl',
          controller: function (setting) {
            this.setting = setting;
          },
          resolve: {
            setting: function ($stateParams, SettingService) {
              return SettingService.findById($stateParams.id);
            }
          }
        })
        .state('app.settings.delete', {
          url: '/:id/delete',
          template: '',
          controllerAs: 'ctrl',
          controller: function ($stateParams, $state, SettingService) {
            SettingService.delete($stateParams.id, function () {
              $state.go('^.list');
            }, function () {
              $state.go('^.list');
            });
          }
        });
    });

})();
